import { ListItemWithIcon, ListItemWithIconProps } from '../ListItemWithIcon/ListItemWithIcon';
import { Block, Inline, Document } from '@contentful/rich-text-types';
import React from 'react';
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

const iconMap: Record<string, ListItemWithIconProps['icon']> = {
  tick: 'Tick',
  cross: 'Error',
  jbtick: 'CheckboxYellow',
};

export const renderListItem = (node: Block | Inline, children: React.ReactNode) => {
  const textContent = documentToPlainTextString(node);
  const pattern = /^{{(\w+)}}/;
  const matches = textContent.match(pattern);
  const iconName = matches ? iconMap[matches[1]] || undefined : undefined;

  if (!matches || !iconName) return <li>{children}</li>;

  return <ListItemWithIcon icon={iconName} content={<ListItemChildren node={node} strToReplace={matches[0]} />} />;
};

const ListItemChildren = ({ node, strToReplace }: { node: Block | Inline; strToReplace: string }) => {
  return (
    <>
      {node.content.map((child, i) => (
        <React.Fragment key={i}>
          {documentToReactComponents(child as Document, {
            renderText: text => text.replace(strToReplace, '').trim(),
          })}
        </React.Fragment>
      ))}
    </>
  );
};
